export default __webpack_public_path__ + "static/media/PGI-Brochure.e1ac8d8a.pdf";